// src/components/Auth.js
import { SignIn } from "@clerk/clerk-react";

export default function Auth() {
  return (
    <div className="flex justify-center mt-16 px-4">
      <SignIn routing="hash" afterSignInUrl="/" afterSignUpUrl="/" />
    </div>
  );
}